import { type Observable, tap } from 'rxjs'
import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import type { Workspace } from '@/features/iam/workspaces/Workspace'
import { setBrandingVariables } from '@/features/shell/theming/theming'
import { chungusMode } from '@/features/shell/chungus-mode'

/**
 * Manages the application theme.
 */
export class ThemeManager implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  /**
   * Constructor.
   *
   * @param workspace$ emits the workspace whose branding to apply.
   */
  constructor(workspace$: Observable<Workspace>) {
    this._lifecycle
      .manage(workspace$.pipe(tap(setBrandingVariables)))
      .manage(chungusMode())
  }

  /** @inheritDoc */
  activate() {
    this._lifecycle.activate()
  }

  /** @inheritDoc */
  deactivate() {
    this._lifecycle.deactivate()
  }
}
